import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import Toggler from 'modules/core/components/Toggler'

interface Props {
  assignToResource?: () => void
  assigned: boolean
  canAssignToResource: boolean
}

const ItemToggler = ({ assigned, assignToResource, canAssignToResource }: Props) => {
  if (!canAssignToResource) return null

  return (
    <Box paddingRight="s16">
      <Toggler disabled={false} active={assigned} type="correct" onChange={assignToResource} />
    </Box>
  )
}

export default ItemToggler
